import { GameQuizMain } from "./GameQuizMain";

new GameQuizMain("canvas");
